// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 768 ? "App" : chunkId) + "." + {"302":"f44ce806","768":"75848b28"}[chunkId] + ".chunk.css";
};